import * as numeral from 'numeral'

export const numberWithCommas = (input: number): string => {
    return numeral(input).format('O,O')
}

export const numberAsCurrency = (input: number, precision: number = 3): string => {
    return numeral(input).format(`O,O.${new Array(precision).fill('O').join('')}`)
}

export const numberWithPercent = (input: number): string => {
    return numeral(input).format('O.OO%')
}
